import React from "react";
import { motion } from "framer-motion";
import { HandCoins, Users, GraduationCap } from "lucide-react";

const REASONS = [
  {
    Icon: HandCoins,
    title: "Affordable, on purpose",
    body: "The goal is to make practical eCommerce education accessible to as many beginners as possible.",
  },
  {
    Icon: Users,
    title: "Committed community",
    body: "A tiny fee helps ensure that everyone who joins is serious about actually launching.",
  },
  {
    Icon: GraduationCap,
    title: "Community over course",
    body: "We would rather build a strong learning community than sell an expensive one-off course.",
  },
];

const WhyOnly99 = () => (
  <section id="why-99" className="section-pad relative">
    <div className="container-x">
      <div className="rounded-[32px] bg-white border border-slate-100 shadow-premium overflow-hidden">
        <div className="grid gap-8 md:grid-cols-[1fr_1.2fr]">
          <div className="p-8 md:p-12 relative overflow-hidden bg-gradient-to-br from-[#052e2b] to-[#0f172a] text-white">
            <div className="aurora opacity-70" aria-hidden />
            <div className="relative z-10">
              <div className="chip-dark">Why ₹2,499?</div>
              <div className="mt-6 font-display font-extrabold leading-[0.95]" style={{ fontSize: "clamp(3rem, 8vw, 6rem)", letterSpacing: "-0.03em" }}>
                <span className="gradient-text-lime">₹2,499</span>
              </div>
              <div className="mt-1 font-mono uppercase tracking-widest text-lime-300 text-sm">
                one-time registration
              </div>
              <p className="mt-6 text-white/80 max-w-md leading-relaxed">
                A price that&apos;s small enough for anyone to say yes, but real enough to make sure
                everyone who joins actually shows up and builds.
              </p>
            </div>
          </div>

          <div className="p-8 md:p-12">
            <div className="grid gap-4">
              {REASONS.map(({ Icon, title, body }, i) => (
                <motion.div
                  key={title}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="flex items-start gap-4 p-5 rounded-2xl border border-slate-100 bg-slate-50/50"
                >
                  <div className="w-11 h-11 rounded-2xl bg-emerald-50 border border-emerald-100 text-emerald-700 grid place-items-center shrink-0">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <div className="font-display font-bold text-slate-900 text-lg">{title}</div>
                    <div className="mt-1 text-sm text-slate-600">{body}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyOnly99;
